import React, { useState, useEffect, useRef } from "react";
import { AutoComplete, ConfigProvider } from "antd";
import { useDebounce } from "../../hooks/useDebounce";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { CloseSquareFilled, PlusOutlined } from "@ant-design/icons";

import "./index.scss";
const SearchAutoComplete = ({
  showAddNew = true,
  searchThunk,
  resultSelector,
  onSelect,
  placeholder,
  status,
   value,
   className,
}) => {
  const [searchText, setSearchText] = useState("");
  const [touched, setTouched] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const hasUnlockedRef = useRef(false); 
  const debouncedSearchText = useDebounce(searchText, 500); // 500ms debounce delay
  
  const handleBlur = () => {
    setTouched(true);
  };
  // Get the search results from Redux
  const searchResults = useSelector(resultSelector, shallowEqual);
  useEffect(() => {
    if (debouncedSearchText.length >= 3) {
      // Dispatch the provided thunk
      searchThunk(debouncedSearchText);
    }
  }, [debouncedSearchText]);

  // Format options for AutoComplete
  const options = searchResults
    ? searchResults?.map((item) => ({
      value: item.display_text,
      label: <div>{item.display_text}</div>, // Customize display as needed
    }))
    : [];

  const handleSelect = (value) => {
    if (value === 'add_new') {
      onSelect(value);
      return
    }
    const selectedObject = searchResults.find(
      (option) => option.display_text === value
    );
    hasUnlockedRef.current = false; // 🔁 reset lock state
    setSelectedValue(value);   // ✅ lock only on select    
    onSelect(selectedObject);
  };

  const handleChange = (value) => {
    setSelectedValue(value || "");
    if ( !value || value.trim() === "" ) {
      hasUnlockedRef.current = false;
      onSelect?.(null);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {},
        },
      }}
    >
      <AutoComplete
        key={placeholder}
        className={className || "searchAutoComplete"}
        value={
          typeof value === "string"
            ? value
            : value?.display_text || selectedValue || ""
        }
        // Full name on hover, in case the table column is too narrow to
        // show it all -- the input itself truncates with an ellipsis (see
        // index.scss) rather than silently clipping without any indicator.
        title={
          typeof value === "string"
            ? value
            : value?.display_text || selectedValue || ""
        }
        // The dropdown panel defaults to matching the (often narrow) table
        // column width, which cuts off long item names with antd's built-in
        // ellipsis on the option text. Letting it size to its content keeps
        // full names readable regardless of how narrow the column is.
        popupMatchSelectWidth={false}
        options={[
          ...(showAddNew ? [{
            value: "add_new",
            label: (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 500 }}>
                <PlusOutlined style={{ marginRight: 8 }} /> Add New
              </div>
            ),
          }] : []), // Spread an empty array instead of an empty object
          ...options, 
        ]}        
        onBlur={handleBlur}
        size="large"
        style={{
          width: "100%",
          height: "100%",
          fontSize: "16px",
        }}
        onChange={handleChange}
        onSelect={handleSelect}
       // onSearch={(text) => setSearchText(text)} // Update search text
        onSearch={(text) => {
        setSearchText(text);

        // 🔥 unlock ONLY ONCE
        // if (!hasUnlockedRef.current && (selectedValue || value)) {
        //   hasUnlockedRef.current = true;
        //   setSelectedValue("");
        //   onSelect?.(null);
        // }
        }}
        allowClear       
        placeholder={`Search ${placeholder}`}
        data-testid="to-branch-select"
      />
    </ConfigProvider>
  );
};

export default SearchAutoComplete;
